import { SVGProps, Ref, forwardRef } from 'react';

export const ATSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H0z" fill="#ED2939" />
        <path d="M0 10h16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" fill="#ED2939" />
        <path d="M0 6h16v4H0z" fill="#EEEEEE" />
    </svg>
));
ATSize16Glyph.displayName = 'ATSize16Glyph';
